export function toInputDate(value) {
  if (!value) return '';

  const iso =
    typeof value === 'string'
      ? value
      : value?.iso;

  if (!iso) return '';

  const d = new Date(iso);

  if (Number.isNaN(d.getTime())) return '';

  return d.toISOString().slice(0, 10);
}

const isTruthyBooleanValue = (value) =>
  value === true ||
  value === 1 ||
  value === '1' ||
  (typeof value === 'string' && value.toLowerCase() === 'true');

export function normalizeUnitRows(data = []) {
  return data.map((r) => {
    const ef = toDisplayIso(r.EFDT);
    return {
      name: String(r.Name),
      effectiveFrom: ef, // { display, iso }
      operator: r.OperatorName || r.Description,
      metersCount: r.MetersCount,
      errorsCount: Number(r.ErrorsCount) || 0,
      stoodDown: isTruthyBooleanValue(r.StoodDown),
      excluded: isTruthyBooleanValue(r.Excluded),
    };
  });
}

export const uniqueNames     = (rows) => [...new Set(rows.map(r => r.name))];
export const uniqueOperators = (rows) => [...new Set(rows.map(r => r.operator))];

export function ddmmyyyyToDate(str) {
  if (!str) return null;
  const parts = String(str).split('/');
  if (parts.length !== 3) return null;
  const [dd, mm, yyyy] = parts.map(Number);
  return new Date(yyyy, (mm || 1) - 1, dd || 1);
}
export function formatName(name) {
  if (!name) return null;
  const trimmed = String(name).trim();
  if (trimmed.includes(',')) {
    const [last, first] = trimmed.split(',').map((s) => s.trim());
    if (first && last) return `${first} ${last}`;
  }
  return trimmed;
}

export function generateFileName(prefix = 'UI') {
  const now = new Date();
  const pad = (n) => String(n).padStart(2, '0');
  return `${prefix}_${now.getFullYear()}${pad(now.getMonth() + 1)}${pad(now.getDate())}${pad(now.getHours())}${pad(now.getMinutes())}${pad(now.getSeconds())}.csv`;
}
// Helper to map ISO or JS-parseable date to display and iso
export const toDisplayIso = (dateStr) => {
  if (!dateStr) return { display: '', iso: '' };
  const dt = new Date(dateStr);
  if (isNaN(dt)) return { display: dateStr, iso: '' };
  return {
    display: dt.toLocaleDateString('en-GB'),
    iso: dt.toISOString(),
  };
};
